<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container" style="max-width: 600px">
        <h2 class="hyper-link mb-3">Log In</h2>
        <p>Log in with your administrator credentials.</p>
        <form class="">
          <div class="row mb-3">
            <div class="col-12 mt-3 text-left">
              <label for="email" class="mb-1 input-label">Email</label>
              <a-input
                :size="'large'"
                placeholder="Provide Email Address"
                @keyup.enter="login()"
                v-model.lazy="$v.loginData.email.$model"
              />
              <div class="error-container" v-if="$v.loginData.email.$error">
                <div class="error-item" v-if="!$v.loginData.email.required">
                  Email is required
                </div>
                <div class="error-item" v-if="!$v.loginData.email.email">
                  Invalid email address
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 text-left">
              <label for="password" class="mb-1 input-label">Password</label>
              <a-input-password
                :size="'large'"
                placeholder="Provide Password"
                @keyup.enter="login()"
                v-model="$v.loginData.password.$model"
              />
              <div class="error-container" v-if="$v.loginData.password.$error">
                <div class="error-item" v-if="!$v.loginData.password.required">
                  Password is required
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="buttons-group mt-5 text-center">
          <a-button
            :loading="loading"
            @click="login()"
            :style="{ background: getPrimaryColor(), color: '#fff !important' }"
            class="dovemed-button font-white login-button"
          >
            <span>LOGIN</span>
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "LoginAdmin",
  data() {
    return {
      loginData: {
        email: null,
        password: null,
      },
      error: false,
      loading: false,
    };
  },
  validations: {
    loginData: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    login() {
      this.loading = true;
      const data = this.loginData;
      this.$v.$touch();
      this.errors = this.$v.loginData.$anyError;
      if (!this.errors) {
        let type;
        if (this.$router.currentRoute.query.role === "hospital") {
          type = "checkhospital";
        } else if (this.$router.currentRoute.query.role === "clinic") {
          type = "checkclinic";
        } else if (this.$router.currentRoute.query.role === "nfc") {
          type = "";
        }
        this.$store
          .dispatch("Auth/adminLogin", { data, type })
          .then((res) => {
            this.loading = false;
            this.$router.push({
              name: "LoginAdminSelect",
              query: { role: this.$router.currentRoute.query.role, info: JSON.stringify(res), user: JSON.stringify(data) }
            })
          })
          .catch((err) => {
            this.loading = false;
            this.$notification.error({
              message: "Error",
              description: err.message,
            });
          });
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-button {
  span {
    color: #fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/LoginAdmin.vue